<template>
  <div>
    <h1>Lista de Páginas CMS</h1>
    <b-card>
      <div class="d-flex mb-2">
        <div class="mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="
                page = 1;
                loadData();
              "
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="loadData" variant="bagsis">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            size="sm"
            variant="bagsis"
            :to="{ name: 'cms_pages_create' }"
            v-if="$can('cms_page:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table striped hover :items="cms_pages" :fields="fields" show-empty>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('cms_page:edit')"
            :view_delete="$can('cms_page:delete')"
            edit_to="cms_pages_edit"
            @delete="delete_cms_page"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
    </b-card>

    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        @input="loadData()"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Actions from "@/components/Table/Actions.vue";
import { slugify } from "@/helpers/functions/slugify";

const pages_status = {
  draft: "Rascunho",
  published: "Publicado",
  archived: "Arquivado",
};

export default {
  components: { Actions },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
  }),
  computed: {
    ...mapState("cms_pages", ["cms_pages", "pagination"]),
    fields() {
      return [
        { key: "actions", label: "", class: "cell-actions" },
        { key: "id", label: "#", class: "col-1" },
        { key: "title", label: "Título" },
        {
          key: "status",
          label: "Status",
          formatter: (val) => pages_status[val],
        },
        { key: "author.name", label: "Autor" },
      ];
    },
    formatedTermoPesquisa() {
      return slugify(this.termo_pesquisa);
    },
  },
  methods: {
    ...mapActions("cms_pages", ["ActionGetAll", "ActionDelete"]),
    async delete_cms_page(cms_page) {
      try {
        await this.ActionDelete(cms_page.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    async loadData() {
      try {
        await this.ActionGetAll({
          page: this.page,
          q: this.formatedTermoPesquisa,
        });
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    this.loadData();
  },
};
</script>

<style></style>
